/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from "react";
import BarsArrowUpIcon from "@src/assets/svg/bars-arrow-up.svg";
import BarsArrowDownIcon from "@src/assets/svg/bars-arrow-down.svg";
import styles from "./ota-history-table-header.module.scss";
import { OTA_TABLE_HEADER as cssClassName } from "../../../cloud-connect/ota-update/constants";
import { SortConfig } from "@src/cloud-connect/utils/sort-table-columns";
import { ListItem } from "@src/types/ota-update";

// Props for OTA table header component
interface OTATableHeaderProps {
  columns: { key: string; label: string }[]; // Columns to render
  columnWidths: { [key: string]: number }; // Dynamic widths for each column
  resizing: {
    // Info about the currently resizing column pair
    handleKey: string;
    leftCol: string;
    rightCol: string;
    startX: number;
    startLeftWidth: number;
    startRightWidth: number;
  } | null;
  handleMouseDown: (
    // Triggered when starting to drag a column resize handle
    e: React.MouseEvent<HTMLDivElement>,
    leftColKey: string,
    rightColKey: string,
  ) => void;
  handleSort: (key: string) => void; // Triggered on header click to sort
  sortConfig: SortConfig<ListItem> | null; // Current sorting configuration
}

// OTA table header component
const OTATableHeader = ({
  columns,
  columnWidths,
  resizing,
  handleMouseDown,
  handleSort,
  sortConfig,
}: OTATableHeaderProps) => {
  return (
    <thead className={styles[cssClassName]}>
      <tr>
        {columns.map((column, index) => (
          <th
            key={column.key}
            // Dynamically set width based on current columnWidths
            style={{ width: `${columnWidths[column.key]}%` }}
            className={styles[`${cssClassName}__header`]}
          >
            {/* Render resize handle for all columns except the first */}
            {index > 0 ? (
              <div
                className={`${
                  styles[`${cssClassName}__header-resize-handle`]
                } ${
                  resizing?.handleKey === column.key
                    ? styles[`${cssClassName}__header-resize-handle--dragging`]
                    : ""
                }`}
                // Mouse down starts column resizing
                onMouseDown={(e) => {
                  e.stopPropagation();
                  handleMouseDown(e, columns[index - 1].key, column.key);
                }}
              />
            ) : (
              // Static handle for the first column
              <div
                className={styles[`${cssClassName}__header-static-handle`]}
              />
            )}

            {/* Header content container */}
            <div
              className={styles[`${cssClassName}__header-content`]}
              // Clicking triggers sorting for this column
              onClick={() => {
                if (resizing) return;
                handleSort(column.key);
              }}
            >
              <span>{column.label}</span>

              {/* Show sort icon if this column is currently sorted */}
              {sortConfig?.key === column.key &&
                (sortConfig.direction === "asc" ? (
                  <img src={BarsArrowUpIcon} alt="" width={14} height={14} />
                ) : (
                  <img src={BarsArrowDownIcon} alt="" width={14} height={14} />
                ))}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default OTATableHeader;
